import { ToggleButtonProps } from "@animech/ui";
import { FunctionComponent } from "react";
import * as Styled from "./menu-button.style";

export type MenuButtonProps = ToggleButtonProps<boolean>;

export const MenuButton: FunctionComponent<MenuButtonProps> = (props) => (
	<Styled.Root {...props}>
		<Styled.Icon>
			<Styled.IconLine />
			<Styled.IconLine />
			<Styled.IconLine />
		</Styled.Icon>
	</Styled.Root>
);
